import reqwest from 'reqwest';
import { apiUrl } from './config';

export default {
  /**
   * 获取我的信息
   */
  getMyInfo() {
    return reqwest({
      url: `${apiUrl}/official-api/api/sys/current`,
    });
  },
  /**
   * 获取我的vip信息
   */
  getMyVipInfo() {
    return reqwest({
      url: `${apiUrl}/official-api/api/sys/getAttendanceVipInfo`,
    });
  },
  /**
   * 绑定手机号码
   */
  bindPhone(data) {
    return reqwest({
      url: `${apiUrl}/official-api/api/sys/bindPhone`,
      data: JSON.stringify(data),
      method: 'post',
      contentType: 'application/json;charset=UTF-8',
    });
  },
  /**
   * 获取会员商品信息
   */
  getMyVipGoodsInfo() {
    return reqwest({
      url: `${apiUrl}/official-api/api/pay/getVipOrderInfo`,
    });
  },
  /**
   * vip转让
   */
  transferMyVip(data) {
    return reqwest({
      url: `${apiUrl}/official-api/api/user/transferAttendanceVip/${data.userId}`,
    });
  },
};
